import React from 'react';
import { FaTrain } from 'react-icons/fa';

const Header = () => (
  <header className="railway-header">
    <h1>🚂 Railway Departmental Promotional Exam Portal</h1>
    <FaTrain />
  </header>
);

export default Header;